import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SecuritySettings = ({ onBackupCreate, onPasswordChange }) => {
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [creatingBackup, setCreatingBackup] = useState(false);

  const handleCreateBackup = async () => {
    setCreatingBackup(true);
    setTimeout(() => {
      onBackupCreate();
      setCreatingBackup(false);
    }, 2000);
  };

  const handlePasswordSubmit = (e) => {
    e?.preventDefault();
    if (passwordData?.newPassword !== passwordData?.confirmPassword) {
      alert('New passwords do not match');
      return;
    }
    onPasswordChange(passwordData);
    setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    setShowPasswordChange(false);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-2">
          Security & Backup
        </h3>
        <p className="text-sm text-muted-foreground">
          Manage security settings and create configuration backups
        </p>
      </div>
      <div className="space-y-4">
        <div className="bg-muted/30 rounded-md p-4">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-start gap-3">
              <Icon name="Shield" size={20} className="text-accent flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="text-sm font-semibold text-card-foreground mb-1">
                  Configuration Backup
                </h4>
                <p className="text-sm text-muted-foreground">
                  Create a backup of current settings and configurations
                </p>
              </div>
            </div>
          </div>
          <Button
            variant="outline"
            onClick={handleCreateBackup}
            loading={creatingBackup}
            iconName="Download"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            {creatingBackup ? 'Creating Backup...' : 'Create Backup'}
          </Button>
        </div>

        <div className="bg-muted/30 rounded-md p-4">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-start gap-3">
              <Icon name="Key" size={20} className="text-accent flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="text-sm font-semibold text-card-foreground mb-1">
                  Change Password
                </h4>
                <p className="text-sm text-muted-foreground">
                  Update your superadmin account password
                </p>
              </div>
            </div>
          </div>
          
          {!showPasswordChange ? (
            <Button
              variant="outline"
              onClick={() => setShowPasswordChange(true)}
              iconName="Lock"
              iconPosition="left"
              className="w-full sm:w-auto"
            >
              Change Password
            </Button>
          ) : (
            <form onSubmit={handlePasswordSubmit} className="space-y-3 mt-4">
              <Input
                type="password"
                label="Current Password"
                placeholder="Enter current password"
                value={passwordData?.currentPassword}
                onChange={(e) => setPasswordData(prev => ({ ...prev, currentPassword: e?.target?.value }))}
                required
              />
              <Input
                type="password"
                label="New Password"
                placeholder="Enter new password"
                value={passwordData?.newPassword}
                onChange={(e) => setPasswordData(prev => ({ ...prev, newPassword: e?.target?.value }))}
                required
              />
              <Input
                type="password"
                label="Confirm New Password"
                placeholder="Confirm new password"
                value={passwordData?.confirmPassword}
                onChange={(e) => setPasswordData(prev => ({ ...prev, confirmPassword: e?.target?.value }))}
                required
              />
              <div className="flex items-center gap-3">
                <Button type="submit" variant="default">
                  Update Password
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => {
                    setShowPasswordChange(false);
                    setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
                  }}
                >
                  Cancel
                </Button>
              </div>
            </form>
          )}
        </div>

        <div className="bg-warning/10 border border-warning/20 rounded-md p-4">
          <div className="flex items-start gap-3">
            <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-foreground mb-1">
                Security Notice
              </p>
              <p className="text-sm text-muted-foreground">
                All configuration changes are logged and can be audited. Ensure you maintain secure backups of critical settings.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;